const requestIdleCallbackPolyfill = (
  cb: (opts: { didTimeout: boolean; timeRemaining: () => number }) => void,
) =>
  setTimeout(() => {
    const start = Date.now();
    cb({
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
    });
  }, 1);

export const requestIdleCallback = (() => {
  if (typeof window !== 'undefined') {
    return window.requestIdleCallback || requestIdleCallbackPolyfill;
  }
  return requestIdleCallbackPolyfill;
})();
